<template>
  <div>
    <loading-spinner :visible="isLoading" />
    <main class="mt-3">
      <div class="pl-1 text-center">
        <div class="alert alert-primary" role="alert">
          <b class="fs-4">근 태 현 황</b>
        </div>
        <div class="mt-3" style="text-align: start; margin-left:5px; width: 1200px;">
          <div>
            <label style="background-color:beige; border-radius: 8px; width: 500px; font-size:1.2rem; font-weight: 600; text-align: center;">
              나의 연차설정 <span class="text-danger fs-6">(※ 승인된 스케쥴만 입력합니다)</span>
            </label>
          </div>
          <div class="mt-3 mb-5">
            <table class="myAttTable">
              <tr style="background-color: azure;">
                <th style="width: 300px; text-align: center;">스케쥴코드</th>
                <th style="width: 800px; text-align: center;">스케쥴</th>
                <th style="width: 500px; text-align: center;">특기사항</th>
                <th style="width: 400px; text-align: center;">스케쥴</th>
              </tr>
              <tr>
                <td>
                  <select class="form-select form-select-sm" v-model="attCode" v-if="user.handlerGrade <= 4">
                    <option value="" disabled>스케쥴코드리스트</option>
                    <option :value="at.procCode" :key="i" v-for="(at, i) in attCodeListForMan">
                      ({{ at.procCode }}) {{ at.procName }}
                    </option>
                  </select>
                  <select class="form-select form-select-sm" v-model="attCode" v-else>
                    <option value="" disabled>스케쥴코드리스트</option>
                    <option :value="at.procCode" :key="i" v-for="(at, i) in attCodeList">
                      ({{ at.procCode }}) {{ at.procName }}
                    </option>
                  </select>                  
                </td>
                <td>
                  <div class="d-flex">
                    <input type="date" class="form-control form-control-sm" v-model="attStart">&nbsp;&nbsp;~&nbsp;&nbsp;
                    <input type="date" class="form-control form-control-sm" v-model="attClose">
                  </div>
                </td>
                <td>
                  <div class="text-center">
                    <textarea class="form-control-sm" placeholder="특기사항을 입력하세요(200자 아내)" style="width: 100%; height:50px;" v-model="attRemarks"></textarea>
                  </div>
                </td>
                <td>
                  <div class="text-center">
                    <button type="button" class="btn btn-primary btn-sm" @click="setMyAttInfo('S')">일정등록</button>&nbsp;&nbsp;
                    <button type="button" class="btn btn-danger btn-sm" @click="setMyAttInfo('D')">일정취소</button>
                  </div>                                            
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="mb-3 col-4 d-flex" style="height: 50px;">
          <div style="width: 600px;" v-if="user.handlerGrade <= 4">
            <select class="form-select form-select-sm" v-model="searchVal">
              <option :value="none" disabled>근태자</option>
              <option value="all">전체보기</option>
              <option :value="hc.handlerId" :key="i" v-for="(hc, i) in empList">
                {{ hc.handlerNameKor }} ({{ hc.handlerId }})
              </option>
            </select>
          </div>
          <div class="input-group" style="height:30px;">
            <input type="month" class="form-control form-control-sm" style="width:100px; font-size: 0.8rem;" v-model="selMonth">
            <button type="button" class="btn btn-primary btn-sm" @click="searchByMonth(searchVal, selMonth)">검색</button>
          </div>
        </div>
        <hr style="border:dashed 2px;" class="mb-5">

        <!-- 근태사항 -->
        <div>
          <div v-if="tableDataForProduct.length">
            <div v-for="employee in tableDataForProduct[0].products" :key="employee.employeeId" style="margin-bottom: 2rem; text-align: left;">
              <label style="font-weight: bold;">
                ▼ {{ employee.employeeName }} <span class="fw-normal text-muted">({{ employee.employeeId }})</span>
              </label>
              <table class="table table-bordered mt-2">
                <thead>
                  <tr style="background-color: #f8f9fa;">
                    <th class="text-center">/</th>
                    <th v-for="date in daysInCurrentMonth" :key="date" class="text-center date-header" :class="{'saturday': getDay(date) === '토', 'sunday': getDay(date) === '일', 'holiday': isHoliday(date)}" :style="{ width: '100px', position: 'relative' }" @mouseenter="showLoginTimesByDate(employee.employeeId, date, $event)" @mouseleave="hideLoginTimes" style="position: relative; cursor: pointer;">
                      {{ date.substring(5) }}({{ getDay(date) }})

                      <!-- 날짜별 로그인 시간 팝오버 -->
                      <div v-if="popover.visible && popover.empId === employee.employeeId && popover.date === date && popover.loginTimes.length > 0" class="login-popover" :style="{ top: popover.top + 'px', left: popover.left + 'px' }">
                        <!-- <div class="login-popover-header">{{ employee.employeeName }} {{ date }} 로그인</div> -->
                        <div v-for="(time, idx) in popover.loginTimes" :key="idx" class="login-time-row">
                          {{ time }}
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <!-- 출근 행 -->
                  <tr>
                    <td class="text-center fw-bold">出</td>
                    <td 
                      v-for="date in daysInCurrentMonth" 
                      :key="date" 
                      class="text-center" 
                      :class="{ 'holidayName': isHoliday(date) }"
                      :style="{
                        backgroundColor: (employee.dates[date] && (
                          employee.dates[date].leaveType || employee.dates[date].atRemarks_starting
                        )) ? '#fff9c4' : ''
                      }" 
                      @click="inputRemarks('ST', employee.employeeId, date, employee.dates[date])"
                    >
                      <div v-if="isHoliday(date)">{{ this.getHolidayName(date) }}</div>

                      <div
                        v-else-if="employee.dates[date] && (
                          employee.dates[date].leaveType || employee.dates[date].atRemarks_starting
                        )" 
                        class="tooltip-wrapper" tabindex="0">

                        <!-- 스케쥴이 있는 경우 -->
                        <template v-if="employee.dates[date].leaveType">
                          <span class="alSKD text-primary" style="font-weight:600;">
                            {{ employee.dates[date].leaveType }}
                          </span>
                          <div class="tooltip-remark">
                            {{ employee.dates[date].atSkdRemarks }}
                          </div>
                        </template>

                        <!-- 스케쥴이 없는 경우 -->
                        <template v-else>
                          <!-- 출근시간이 있는 경우 -->
                          <template v-if="employee.dates[date].timeStart">
                            <!-- 지각출근 -->
                            <span v-if="isAfterStart(employee.dates[date].timeStart)" class="text-danger">
                              {{ employee.dates[date].timeStart }}
                            </span>
                            <!-- 정상출근 -->
                            <span v-else>
                              {{ employee.dates[date].timeStart }}
                            </span>
                          </template>
                          <!-- 출근시간이 없지만 특기사항이 있는 경우 -->
                          <span v-else class="text-muted">-</span>
                          
                          <div class="tooltip-remark">
                            {{ employee.dates[date].atRemarks_starting }}
                          </div>
                        </template>
                      </div>

                      <template v-else>
                        <template v-if="employee.dates[date]">
                          <span v-if="employee.dates[date].leaveType" class="alSKD text-primary" style="font-weight:600;">
                            {{ employee.dates[date].leaveType }}
                          </span>
                          <template v-else-if="employee.dates[date].timeStart">
                            <span v-if="isAfterStart(employee.dates[date].timeStart)" class="text-danger">
                              {{ employee.dates[date].timeStart }}
                            </span>
                            <span v-else>
                              {{ employee.dates[date].timeStart }}
                            </span>
                          </template>
                        </template>
                        <span v-else></span>
                      </template>
                    </td>
                  </tr>
                  <!-- 퇴근 행 -->
                  <tr>
                    <td class="text-center fw-bold">退</td>
                    <td v-for="date in daysInCurrentMonth" :key="date" class="text-center" 
                      :style="{backgroundColor: (employee.dates[date] && (employee.dates[date].leaveType || employee.dates[date].atRemarks_closing)) ? '#fff9c4' : '' }" 
                      @click="inputRemarks('CL', employee.employeeId, date, employee.dates[date])">
                      <div v-if="employee.dates[date] && (employee.dates[date].leaveType || employee.dates[date].atRemarks_closing)" class="tooltip-wrapper" tabindex="0">
                        <!-- 스케쥴이 있는 경우 -->
                        <template v-if="employee.dates[date].leaveType">
                          <span class="alSKD text-primary" style="font-weight:600;">
                            {{ employee.dates[date].leaveType }}
                          </span>
                          <div class="tooltip-remark">
                            {{ employee.dates[date].atSkdRemarks }}
                          </div>
                        </template>
                        
                        <!-- 스케쥴이 없는 경우 -->
                        <template v-else>
                          <!-- 퇴근시간이 있는 경우 -->
                          <template v-if="employee.dates[date].timeClose">
                            <!-- 조퇴 -->
                            <span v-if="isBeforeClose(employee.dates[date].timeClose)" class="text-danger">
                              {{ employee.dates[date].timeClose }}
                            </span>
                            <!-- 정상퇴근 -->
                            <span v-else>
                              {{ employee.dates[date].timeClose }}
                            </span>
                          </template>
                          <!-- 퇴근시간이 없지만 특기사항이 있는 경우 -->
                          <span v-else class="text-muted">-</span>
                          
                          <div class="tooltip-remark">
                            {{ employee.dates[date].atRemarks_closing }}
                          </div>
                        </template>
                      </div>
                      
                      <template v-else>
                        <template v-if="employee.dates[date]">
                          <span v-if="employee.dates[date].leaveType" class="alSKD text-primary" style="font-weight:600;">
                            {{ employee.dates[date].leaveType }}
                          </span>
                          <template v-else-if="employee.dates[date].timeClose">
                            <span v-if="isBeforeClose(employee.dates[date].timeClose)" class="text-danger">
                              {{ employee.dates[date].timeClose }}
                            </span>
                            <span v-else>
                              {{ employee.dates[date].timeClose }}
                            </span>
                          </template>
                        </template>
                        <span v-else></span>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import dayjs from "dayjs";
import LoadingSpinner from '../components/LoadingSpinner.vue';

export default {
  components: { LoadingSpinner },
  data() {
    return {
      isLoading: false,
      searchVal: "",
      selMonth: "",
      attCodeList: [],
      attCodeListForMan: [],    // 관리자용 스케쥴코드 리스트
      attCode: "",
      attStart: "",
      attClose: "",
      attRemarks: "",
      currentYear: dayjs().year(),
      currentMonth: dayjs().month() + 1,
      daysInCurrentMonth: [],
      empList: [],
      attDatePerEmp: [],
      attDatePerEmp_org: [],
      attDatePerEmp_show: [],
      annualLeaveSKD: [],
      tableDataForProduct: [],
      loginInfo: [],

      // 로그인 시간 팝오버 상태
      popover: {
        visible: false,
        empId: "",
        date: "",
        loginTimes: [],
        top: 0,
        left: 0
      },

      dayOffList_curYear: [], // 현재 연도의 휴일 리스트
    };
  },
  created() {
    this.user = this.$store.state.user;
    this.getAttCodeLsit();
    this.getEmpList();
    this.getAttDataPerEmp('');
    this.getLoginInfoPerDay();
    this.getDayOffLsit_CurYear('cur');       // 당해연도 휴일리스트
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    if(document.referrer == "") 
    {
      this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
      location.replace("/")
    }
    
    if(this.user.handlerGrade >= 20) 
    {
      var swal = require('sweetalert2');
      swal.fire({
        title: '로그인 필요',
        text: '접근권한 확인불가.',
        icon: 'error'
      });
      this.$router.push({path: '/'});
    }
    document.getElementById("user").style.display = "none";
    this.daysInMonth() 
  },
  
  methods: {
    getDateFormat(date) {
      return this.$dateFormat(date);
    },    
    //지각체크
    isAfterStart(time, base = '09:00:00') {
      return time && base && time.localeCompare(base) > 0;
    },

    //조퇴체크
    isBeforeClose(time, base = '18:00:00') {
      return time && base && time.localeCompare(base) < 0;
    },

    //(대체)공휴일 체크
    isHoliday(date) {
      return this.dayOffList_curYear.some(holiday => this.getDateFormat(holiday.doDate) === date);
    },

    //휴일이름 가져오기
    getHolidayName(date) {
      const found = this.dayOffList_curYear.find(holiday => this.getDateFormat(holiday.doDate) === date);
      return found ? found.doName : null;
    },

    async getAttCodeLsit() {
      let attCodeList_tmp = await this.$api("/api/attCodeList", {});
      if(attCodeList_tmp.length > 0) 
      {
        this.attCodeListForMan = attCodeList_tmp;
        this.attCodeList = attCodeList_tmp.filter(item => item.procEndFlag !== 'Y');
      }
    },

    async getEmpList() {
      let empList = await this.$api("/api/empList", {});
      if(empList.length > 0) 
      {
        this.empList = empList;
      }
    },

   //요일표시용
    getDay(date) {
      const week = ['일', '월', '화', '수', '목', '금', '토'];
      return week[new Date(date).getDay()];
    },

    //당해연도 휴일리스트
    async getDayOffLsit_CurYear(param) {
      let dayOffList_curYear = [];

      if(param === 'cur') 
      {
        dayOffList_curYear = await this.$api("/api/doDateList_CurYear", {});
      }
      else if(param && param != 'cur')
      {
        let selYear = param.substring(0, 4);
        dayOffList_curYear = await this.$api("/api/doDateList_selMonth", {param: [selYear]});
      }
      
      if(dayOffList_curYear.length > 0) 
      {
        this.dayOffList_curYear = dayOffList_curYear;
      }
      //console.log("dayOffList_curYear::::::", this.dayOffList_curYear)
    },

    async inputRemarks(type, empId, date) {
      //console.log(type, empId, date)
      if(this.user.handlerId != empId)
      {
        this.$swal.fire('', '특기사항 사후등록은 본인의 근태에 한정됩니다', 'warning');
        return;
      }

      const inputIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-person-workspace" viewBox="0 0 16 16"><path d="M4 16s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-5.95a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/><path d="M2 1a2 2 0 0 0-2 2v9.5A1.5 1.5 0 0 0 1.5 14h.653a5.4 5.4 0 0 1 1.066-2H1V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v9h-2.219c.554.654.89 1.373 1.066 2h.653a1.5 1.5 0 0 0 1.5-1.5V3a2 2 0 0 0-2-2z"/></svg>'

      this.$swal.fire({
        iconHtml: inputIcon,
        html: '특기사항 사후등록',
        showCancelButton: true,
        inputLabel: '▼특기사항(선택, 100자 이내)',
        input: 'text',
        confirmButtonText: '등록',
        cancelButtonText: '취소',
        draggable: true,
      })
      .then(async (result) => {
        if(result.isConfirmed && result.value) 
        {
          let remarks = result.value.trim();
          if(remarks.length > 100) 
          {
            this.$swal.fire('', '특기사항은 100자 이내로 입력이 가능합니다.', 'warning');
            return false;
          }

          if(type === 'ST') 
          {
            let upd_attRemarks_start = await this.$api("/api/upd_attRemarks_start", {param: [
              remarks, this.user.handlerId, date, this.user.handlerId
            ]});
            if(upd_attRemarks_start.affectedRows > 0) 
            {
              this.$swal.fire("", "출근특기사항이 저장되었습니다.", "info")
              .then(() => { location.reload(true) });
            } 
            else 
            {
              this.$swal.fire("", "퇴근특기사항 저장이 실패했습니다.<br>근태기록이 없는경우, 사후입력은 불가능합니다.", "warning");
              return false;
            }
          }

          if(type === 'CL') 
          {
            let upd_attRemarks_close = await this.$api("/api/upd_attRemarks_close", {param: [
              remarks, this.user.handlerId, date, this.user.handlerId
            ]});
            if(upd_attRemarks_close.affectedRows > 0) 
            {
              this.$swal.fire("", "퇴근특기사항이 저장되었습니다.", "info")
              .then(() => { location.reload(true) });
            } 
            else 
            {
              this.$swal.fire("", "퇴근특기사항 저장이 실패했습니다.<br>근태기록이 없는경우, 사후입력은 불가능합니다.", "warning");
              return false;
            }
          }
        }
        // else if(result.isDismissed) 
        // {
        //   console.log("취소됨");
        // }
        // else 
        // {
        //   console.log("입력값 없음");
        // }
      })
    },
    
    async setMyAttInfo(flag) {
      if(this.attCode == undefined || this.attCode === "" || this.attCode == null)   
      {
        this.$swal.fire('', '근태코드를 선택해주세요', 'warning');
        return;
      }

      if(this.attStart == "" || this.attClose == "") 
      {
        this.$swal.fire('', '시작일과 종료일을 입력해 해주세요', 'warning');
        return;
      }

      let attUseFlag = ""
      if(flag === "S")
      {
        attUseFlag = "Y"
        let ins_attSKD = await this.$api("/api/insertAttendanceSKD", {param: [
          this.user.handlerId, attUseFlag, this.attCode, this.attStart, this.attClose, this.attRemarks
        ]})
        
        if(ins_attSKD.affectedRows > 0 ) 
        {
          this.$swal.fire('', '스케쥴이 생성되었습니다.', 'success')
          .then(() => { location.reload(true) })
        } 
        else 
        {
          this.$swal.fire('', '스케쥴 생성이 실패했습니다. 재생성 해주세요', 'warning')
          return false
        }
      } 
      else if(flag === "D") 
      {
        attUseFlag = "N"
        let cxl_attSKD = await this.$api("/api/cxlAttendanceSKD", {param: [
          attUseFlag, this.user.handlerId, this.user.handlerId, this.attCode, this.attStart, this.attClose
        ]})
        
        if(cxl_attSKD.affectedRows > 0 ) 
        {
          this.$swal.fire('', '스케쥴이 취소되었습니다.', 'info')
          .then(() => { location.reload(true) })
        } 
        else 
        {
          this.$swal.fire('', '스케쥴 취소가 되지 않습니다. 재시도 해주세요.', 'warning')
          return false
        }
      } 
      else 
      {
        this.$swal.fire('', '스케쥴코드를 선택해주세요', 'warning');
        return;
      }
    },

    daysInMonth() {
      const days = [];
      let year = this.currentYear;
      let month = this.currentMonth;
      if (this.selMonth && this.selMonth !== "" && this.selMonth != undefined) 
      {
        year = this.selMonth.split("-")[0];
        month = this.selMonth.split("-")[1];
      }
      const daysInCurrentMonth = dayjs(`${year}-${month}-01`).daysInMonth();
      
      for (let i = 1; i <= daysInCurrentMonth; i++) 
      {
        days.push(dayjs(`${year}-${month}-${i}`).format("YYYY-MM-DD"));
      }
      this.daysInCurrentMonth = days;
    },

    async getLoginInfoPerDay() {
      let loginInfo = await this.$api("/api/loginPerDay", {})

      if(loginInfo.length > 0) 
      {
        this.loginInfo = loginInfo;
      }

      //console.log("loginInfo:::::::", this.loginInfo)
    },

    async searchByMonth(catCode, selMonth) {
      if (!selMonth && !catCode) {
        this.$swal.fire('', '조회조건이 없습니다.', 'warning');
        return;
      }
      this.selMonth = selMonth;
      this.daysInMonth();
      this.getDayOffLsit_CurYear(selMonth)

      if(catCode == "all" || !catCode) 
      {
        this.getAttDataPerEmp('')
      } 
      else 
      {
        this.getAttDataPerEmp(catCode)
      }
      this.searchVal = ""
      //this.selMonth = ""
    },

    async getAttDataPerEmp(id) {
      let attDatePerEmp = await this.$api("/api/attDataPerEmp", {})
      
      let annualLeaveSKD = []
      if(this.selMonth == "") 
      {
        annualLeaveSKD = await this.$api("api/annualLeaveSKD", {})
      }
      else if(this.selMonth != "") 
      {
        annualLeaveSKD = await this.$api("api/annualLeaveSKD_show", { param: [ this.selMonth ] })
      }

      if(annualLeaveSKD.length > 0) 
      {
        this.annualLeaveSKD = annualLeaveSKD
      }
      
      if(attDatePerEmp.length > 0) 
      {
        this.attDatePerEmp_org = attDatePerEmp
        this.attDatePerEmp = attDatePerEmp

        if(id == "") 
        {
          if(this.user.handlerGrade <= 4) 
          {
            this.attDatePerEmp_show = attDatePerEmp
            this.annualLeaveSKD = annualLeaveSKD
          } 
          else if(this.user.handlerGrade > 4) 
          {
            this.attDatePerEmp_show = attDatePerEmp.filter(item => item.handlerId === this.user.handlerId)
            // this.annualLeaveSKD = annualLeaveSKD.filter(item => item.atId === this.user.handlerId)
            this.annualLeaveSKD = annualLeaveSKD
          }
        } 
        else if(id != "") 
        {
          this.attDatePerEmp_show = attDatePerEmp.filter(item => item.handlerId === id)
          this.annualLeaveSKD = annualLeaveSKD.filter(item => item.atId === id)
        }
      } 
      else 
      {
        this.$swal.fire('', '근태데이타가 없습니다.', 'warning');
        return false;
      }

      // console.log("attDatePerEmp_show:>>>>", this.attDatePerEmp_show)
      // console.log("annualLeaveSKD:>>>>", this.annualLeaveSKD) 

      this.transformData()
    },

    transformData() {
      this.isLoading = true;
      try {
        const groupedByEmployee = {};
        this.attDatePerEmp_show.forEach(item => {
          const empId = item.handlerId;
          if (!groupedByEmployee[empId]) {
            groupedByEmployee[empId] = {
              employeeId: empId,
              employeeName: item.handlerNameKor,
              dates: {}
            };
          }
          const dateKey = item.atDate;
          groupedByEmployee[empId].dates[dateKey] = {
            date: dateKey,
            timeStart: item.time_start || '',
            timeClose: item.time_close || '',
            atRemarks_starting: item.atRemarks_starting || '',
            atRemarks_closing: item.atRemarks_closing || '',
          };
        });
        this.annualLeaveSKD.forEach(leave => {
          const empId = leave.atId || leave.handlerId;
          if (!groupedByEmployee[empId]) {
            groupedByEmployee[empId] = {
              employeeId: empId,
              employeeName: leave.handlerNameKor,
              dates: {}
            };
          }
          const startDate = dayjs(leave.atSkd_start).format("YYYY-MM-DD");
          const endDate = dayjs(leave.atSkd_close).format("YYYY-MM-DD");
          let currentDate = startDate;
          while (dayjs(currentDate).isBefore(endDate) || dayjs(currentDate).isSame(endDate)) {
            groupedByEmployee[empId].dates[currentDate] = {
              date: currentDate,
              leaveType: leave.procName,
              atSkdRemarks: leave.atSkdRemarks || '',
            };
            currentDate = dayjs(currentDate).add(1, 'day').format("YYYY-MM-DD");
          }
        });
        this.tableDataForProduct = [{
          category: 'attendance',
          products: Object.values(groupedByEmployee)
        }];
      } 
      finally 
      {
        this.isLoading = false;
      }

      //console.log("tableDataForProduct:>>>>", this.tableDataForProduct)
    },

    // 특정 직원의 특정 날짜 로그인 시간 팝오버 표시
    showLoginTimesByDate(empId, date, event) {
      // loginInfo에서 해당 직원의 해당 날짜 로그인 기록만 추출
      const loginTimes = this.loginInfo
        .filter(item => item.attId === empId && item.attDate.slice(0, 10) === date)
        .map(item => item.attTime)
        .sort(); // 시간순 정렬

      // 로그인 기록이 있을 때만 팝오버 표시
      if (loginTimes.length > 0) {
        const rect = event.target.getBoundingClientRect();
        this.popover = {
          visible: true,
          empId,
          date,
          loginTimes,
          top: rect.height + 4,
          left: 0
        };
      }
    },

    // 로그인 시간 팝오버 숨기기
    hideLoginTimes() {
      this.popover.visible = false;
      this.popover.empId = "";
      this.popover.date = "";
      this.popover.loginTimes = [];
    }
  }
}
</script>

<style scoped>
input {
  width: 100%;
  box-sizing: border-box;
}
.myAttTable th,td {
  border: 1px solid black;
}
.alSKD {
  color: #0d6efd !important;
  font-weight: 600;
  background-color: #e7f1ff;
  padding: 2px 5px;
  border-radius: 4px;
}

.tooltip-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
}
.tooltip-remark {
  visibility: hidden;
  opacity: 0;
  min-width: 180px;
  max-width: 300px;
  background: #333;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 8px 12px;
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 100%;
  transform: translateX(-50%);
  margin-top: 4px;
  font-size: 0.95rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  white-space: pre-line;
  word-break: break-all;
  pointer-events: none;
  transition: opacity 0.2s;
}
.tooltip-wrapper:hover .tooltip-remark,
.tooltip-wrapper:focus-within .tooltip-remark {
  visibility: visible;
  opacity: 0.7;
  pointer-events: auto;
}

/* 날짜 헤더 스타일 */
.date-header:hover {
  background-color: #e9ecef !important;
}

/* 로그인 시간 팝오버 스타일 */
.login-popover {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  min-width: 150px;
  max-width: 250px;
  background: #ffffffda;
  border: 1px solid #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  z-index: 30;
  padding: 2px;
  font-size: 0.85rem;
  margin-top: 1px;
  text-align: left;
}
.login-popover-header {
  font-weight: bold;
  font-size: 0.8rem;
  color: #666;
  border-bottom: 1px solid #eee;
  margin-bottom: 1px;
  padding-bottom: 1px;
  text-align: center;
}
.login-time-row {
  padding: 1px 0;
  border-bottom: 1px solid #f0f0f0;
  font-family: monospace;
  color: #007bff;
  text-align: center;
}
.login-time-row:last-child {
  border-bottom: none;
}

.saturday {
  color: blue;
}
.sunday {
  color: red;
}

.holiday {
  color: orange !important;
}

.holidayName {
  color: darkorange;
  font-size: 0.8rem;
}
</style>
